import '../css/dashboardCss/dashboard.css'
export const DashboardFooter = () =>{
  return(
    <div>
      <div className='dashboard-footer'>
        <p>Copyright <i class="bi bi-c-circle sm-text-2"></i> 2025 Dashboard. All rights reserved.</p>
      </div>
    </div>
  )
}